import { render, staticRenderFns } from "./counterpartiesArchiveBread.vue?vue&type=template&id=18892b97"
var script = {}
import style0 from "./counterpartiesArchiveBread.vue?vue&type=style&index=0&id=18892b97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports